import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import VisibilityFilterToggles from '@/components/buttons/VisibilityFilterToggles';
import Filter from '@/components/Filter';
import { fetchCohorts, updateCohortsFilter, updateCohortsFlags } from '../actions';

const CohortsFilters = ({
  category,
  privateFlag,
  internalFlag,
  updateFlags,
  filterTerm,
  updateFilterTerm,
  fetchData,
  readErrors,
  className,
  fluid,
}) => (
  <Filter
    fluid={fluid}
    className={clsx('aridhia-cohorts-filter', className)}
    filterTerm={filterTerm}
    updateFilter={({ value }) => updateFilterTerm(category, value)}
    error={firstErrorMessage(readErrors)}
    onFilter={() => fetchData(category, 1, null, false)}
    label={(
      <VisibilityFilterToggles
        entity="cohorts"
        privateFlag={privateFlag}
        internalFlag={internalFlag}
        updateFlags={(flags) => updateFlags(category, flags)}
      />
)}
  />
);

const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
}, { category }) => {
  const {
    filter, privateFlag, internalFlag, readErrors,
  } = cohorts[category];

  return (
    {
      filterTerm: filter,
      privateFlag,
      internalFlag,
      readErrors,
    }
  );
};

const mapDispatchToProps = {
  updateFlags: updateCohortsFlags,
  updateFilterTerm: updateCohortsFilter,
  fetchData: fetchCohorts,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortsFilters);
